import React from 'react';
import './VideoKinematicsHub.css';

interface VideoKinematicsHubProps {
  playerId: number;
  playerName?: string;
  onBack: () => void;
  onCreateNew: () => void;
  onViewLibrary: () => void;
}

const VideoKinematicsHub: React.FC<VideoKinematicsHubProps> = ({
  playerId,
  playerName,
  onBack,
  onCreateNew,
  onViewLibrary
}) => {
  return (
    <div className="video-kinematics-hub">
      <div className="hub-header">
        <button className="back-button" onClick={onBack}>
          ← Back to Dashboard
        </button>
        <h1>Video Kinematics</h1>
        {playerName && (
          <p className="player-name">{playerName}</p>
        )}
      </div>

      <div className="hub-content">
        <div className="hub-actions">
          <button
            className="hub-action-button create-new"
            onClick={onCreateNew}
          >
            <div className="action-icon">➕</div>
            <div className="action-title">Create New Video Kinematics Analysis</div>
            <div className="action-description">
              Upload a video or manually enter metrics to analyze player movement
            </div>
          </button>

          <button
            className="hub-action-button view-library"
            onClick={onViewLibrary}
          >
            <div className="action-icon">📚</div>
            <div className="action-title">View Previous Video Analyses</div>
            <div className="action-description">
              Browse and review saved video kinematics analyses
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoKinematicsHub;






